export default __webpack_public_path__ + "6a8329bd1148a04772a360a13657597c.jpg";